<template>
  <div class="home">
    <img class="bj" src="../assets/home/bj.png" />
    <van-sticky>
      <div class="search row">
        <div class="search-item row">
          <input v-model="keyword" />
          <span class="content" @click="onSearch">搜索</span>
        </div>
      </div>
    </van-sticky>
    <div class="main">
      <van-swipe
        class="banners-swipe"
        :autoplay="3000"
        indicator-color="#FF7669"
      >
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.img_url" @click="goBannerUrl(item.url)" />
        </van-swipe-item>
      </van-swipe>
      <div class="category row">
        <!--        <div class="category-item col" v-for="(item,index) in categories" :key="index" @click="$router.push({name:item.routerName,params:{category_id:item.category_id}})">-->
        <!--          <img src="../assets/logo.png">-->
        <!--          <span class="small-content topic-color">{{item.name}}</span>-->
        <!--        </div>-->

        <div
          class="category-item col"
          v-for="(item, index) in categories"
          :key="index"
          @click="
            $router.push({
              name: item.routerName,
              params: { category_id: item.category_id },
            })
          "
        >
          <img :src="'/qiubih5/img/' + item.icon + '.png'" />
        </div>
      </div>

      <div class="list-block">
        <div class="header row">
          <div class="left-line"></div>
          <span class="small-content topic-color">私人订制</span>
          <img src="../assets/home/wawa.png" />
        </div>
        <van-tabs
          v-model="active"
          line-height="0"
          title-active-color="#EE7060"
          @change="changeTab"
        >
          <van-tab
            v-for="(item, index) in privateCat"
            :key="index"
            :name="item.id"
          >
            <template #title>
              <img v-if="item.id === active" :src="item.active_icon_url" />
              <img v-else :src="item.icon_url" />
              <span class="content">{{ item.name }}</span>
            </template>
          </van-tab>
        </van-tabs>
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="col menu-item"
            v-for="(item, index) in showList"
            :key="index"
            @click="
              $router.push({ name: 'menu', params: { menu_id: item.id } })
            "
          >
            <van-image
              width="100%"
              height="40vw"
              fit="cover"
              :src="item.primary_img_url"
            />
            <div class="small-content topic-color van-ellipsis">
              {{ item.title }}
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <wechat-share></wechat-share>
    <!--    <van-popup v-model="showNotice" close-on-click-overlay="false">-->
    <!--      <div class="col notice">-->
    <!--        <img src="../assets/home/notice.png">-->
    <!--        <img src="../assets/home/close.png" @click="showNotice=false">-->
    <!--      </div>-->
    <!--    </van-popup>-->
  </div>
</template>

<script>
// @ is an alias to /src
import wechatShare from "../components/wechatShare";

export default {
  name: "Home",
  components: {
    wechatShare,
  },
  data() {
    return {
      keyword: "",
      bannerList: [],
      categories: [
        { name: "推荐TOP榜", routerName: "top", icon: "TOP" },
        { name: "产品菜谱", routerName: "product_menu", icon: "product-menu" },
        { name: "一日三餐", routerName: "daily_menu", icon: "daily-menu" },
        {
          name: "当季美食",
          routerName: "cat_menu_list",
          category_id: "",
          icon: "season",
        },
        { name: "美食视频", routerName: "video", icon: "video" },
        { name: "公司介绍", routerName: "product", icon: "product" },
      ],
      privateCat: [],
      active: "",

      menusList: [],
      showList: [],
      allCount: 0,
      loading: false,
      finished: false,
      pageNum: 1,

      showNotice: true,
    };
  },
  created() {
    var that = this;
    that.getBanner();
    that.getPrivateCat();
    that.getCategories();
    if (that.$route.meta.keepAlive === false) {
      window.scrollTo(0, 0);
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.name === "menu") {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "loading") {
      to.meta.keepAlive = false;
    }
    next((vm) => {
      vm.showNotice = true;
    });
  },
  methods: {
    getBanner() {
      var that = this;
      that
        .$get("/banners")
        .then((res) => {
          if (res.code === 200) {
            that.bannerList = res.data;
          } else {
            that.$toast.fail(res.message);
          }
        })
        .catch((err) => {
          that.$toast.fail("网络错误，请稍后再试");
        });
    },
    getPrivateCat() {
      var that = this;
      that
        .$get("/categories", {
          position: 4,
        })
        .then((res) => {
          if (res.code === 200) {
            that.privateCat = res.data.categories;
            that.getShowMenu(that.privateCat[0].id);
          } else {
            that.$toast.fail(res.message);
          }
        })
        .catch((err) => {
          that.$toast.fail("网络错误，请稍后再试");
        });
    },

    //获取当季美食cat_id
    getCategories() {
      var that = this;
      that
        .$get("categories", {
          position: 3,
        })
        .then((res) => {
          if (res.code === 200) {
            that.categories[3].category_id = res.data.show;
          } else {
            that.$toast.fail(res.message);
          }
        })
        .catch((err) => {
          that.$toast.fail("网络错误，请稍后再试");
        });
    },
    getShowMenu(category_id) {
      var that = this;
      that
        .$get("h5/category/menus", {
          category_id: category_id,
          page: that.pageNum,
        })
        .then((res) => {
          if (res.code === 200) {
            that.allCount = res.data.all_count;
            that.menusList = res.data.category_menus;
            that.menusList.forEach(function (item) {
              that.showList.push(item);
            });
            that.pageNum += 1;

            // 加载状态结束
            that.loading = false;

            // 数据全部加载完成

            if (that.showList.length >= that.allCount) {
              that.finished = true;
            }
          } else {
            that.$toast.fail(res.message);
          }
        })
        .catch((err) => {
          that.$toast.fail("网络错误，请稍后再试");
        });
    },
    onLoad() {
      var that = this;
      that.loading = true;
      var times = Math.ceil(that.allCount / 10);
      if (that.pageNum <= times) {
        that.getShowMenu(that.active);
      }
    },
    changeTab(name) {
      var that = this;
      that.menusList = [];
      that.showList = [];
      that.allCount = 0;
      that.finished = false;
      that.finished = false;
      that.pageNum = 1;
      that.getShowMenu(name);
    },
    onSearch() {
      var that = this;
      if (that.keyword) {
        that.$router.push({
          name: "search",
          params: { keyword: that.keyword },
        });
      } else {
        that.$toast.fail("请输入搜索关键词");
        // that.$router.push({
        //   name: "product_menu",
        // });
      }
    },
    goBannerUrl(url) {
      window.location.href = url;
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  min-height: 100vh;
  font-weight: 500;
  .bj {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
  }
  .search {
    background-color: #f9dddd;
    height: 100px;
    justify-content: center;
    align-items: center;
    .search-item {
      background-color: #ee7060;
      border-radius: 50px;
      width: 90%;
      height: 50px;
      align-items: center;
      input {
        background-color: white;
        border-radius: 50px;
        width: 75%;
        height: 50px;
        border: none;
        padding: 0 20px;
        font-size: 30px;
      }
      span {
        width: 25%;
        color: white;
      }
    }
  }
  .main {
    padding: 0 20px;
  }
  .banners-swipe {
    img {
      width: 100%;
      margin: 0 auto;
      display: block;
      border-radius: 20px;
    }
  }
  .category {
    flex-wrap: wrap;
    padding: 30px 60px;
    justify-content: space-between;

    .category-item {
      width: 20vw;
      height: 20vw;
      align-items: center;
      justify-content: center;
      background-color: #f9ddde;
      border-radius: 50%;
      margin-bottom: 10px;

      img {
        width: 100%;
      }
    }
  }
  .list-block {
    .header {
      border-bottom: 1px solid #f9dddd;
      align-items: flex-end;
      .left-line {
        width: 6px;
        height: 30px;
        background-color: #ee7060;
        border-radius: 20px;
        margin-right: 10px;
        margin-bottom: 3px;
      }
      img {
        height: 53px;
      }
    }
    .van-tabs {
      margin: 20px 0;
      /deep/.van-tabs__wrap {
        height: 50px;
      }
      /deep/.van-hairline--top-bottom {
        border: none;
      }
      /deep/.van-hairline--top-bottom::after {
        border: none;
      }
      /deep/.van-tab__text {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      /deep/.van-tab {
        border-right: 1px solid #f9dddd;
        img {
          width: 30px;
          margin-right: 5px;
        }
      }

      /deep/.van-tab:nth-child(4) {
        border-right: 0px solid #f9dddd;
      }
    }
    .list {
      min-height: 85vh;
      .menu-item {
        background-color: #f9dddd;
        border-radius: 20px;
        align-items: center;
        margin-bottom: 20px;
        .van-image {
          /deep/img {
            width: 100%;
            border-radius: 20px;
          }
        }
        .small-content {
          line-height: 70px;
        }
      }
    }
  }

  .notice {
    align-items: center;
    img:nth-child(1) {
      width: 600px;
    }
    img:nth-child(2) {
      width: 55px;
    }
  }
  .van-popup {
    background: none;
  }
  /deep/.van-overlay {
    background-color: rgba(0, 0, 0, 0.6);
  }
}
</style>
